import $ from "jquery";
import * as bootstrap from "bootstrap";

// Log errors
window.onerror = function (m, u, l) {
    $.get("/err", {
        uuid: window.location.href.split('/').slice(-1)[0],
        message: m,
        file: u,
        line: l,
        agent: navigator.userAgent,
        url: window.location.href,
        referer: document.referrer
    });
    return false;
};

// Handle Turbo Frame events for sidebar content
$(document).ready(function() {
    // Reinitialize customize functionality when aside frame loads
    $(document).on('turbo:frame-load', async function(event) {
        if (event.target.id === 'aside-frame') {
            // Reinitialize any other components that might need it
            if (typeof window.init_customization_defaults === 'function') {
                window.init_customization_defaults();
            }
            
            // Focus product name field if upload form is loaded
            if ($('#normal_upload_product_name').length) {
                setTimeout(() => $('#normal_upload_product_name')[0].focus(), 500);
            }
            
            // Initialize uploaders for video and folder uploads
            if ($('#video_upload').length && typeof VideoUploader !== 'undefined') {
                const videoRoot = document.querySelector('#video_upload');
                if (videoRoot && !videoRoot.hasAttribute('data-uploader-initialized')) {
                    const videoUploader = new VideoUploader(videoRoot);
                    videoRoot.setAttribute('data-uploader-initialized', 'true');
                }
            }
            
            if ($('#folder_upload').length && typeof FolderUploader !== 'undefined') {
                const folderRoot = document.querySelector('#folder_upload');
                if (folderRoot && !folderRoot.hasAttribute('data-uploader-initialized')) {
                    const folderUploader = new FolderUploader(folderRoot);
                    folderRoot.setAttribute('data-uploader-initialized', 'true');
                }
            }
        }
    });
    
    // Handle search form submission in action navigation
    $(document).on('keypress', '.nav-link .form-control-sm', function(e) {
        if (e.which === 13) { // Enter key
            e.preventDefault();
            $(this).closest('form').submit();
        }
    });
    
    // (migrated to Stimulus navbar_actions_controller.js)
    

});

document.addEventListener('DOMContentLoaded', function() {
  // Navbar scroll behavior (guard against missing navbar on public pages)
  var navbar = document.querySelector('.navbar.fixed-top');
  if (navbar) {
    function onScroll() {
      if (window.scrollY > 0) {
        navbar.classList.add('scrolled');
      } else {
        navbar.classList.remove('scrolled');
      }
    }
    window.addEventListener('scroll', onScroll);
    onScroll(); // initialize on load
  }

  // Instantly update nav active state on click
  document.body.addEventListener('click', function(e) {
    const navLink = e.target.closest('#navbar-actions .nav-link');
    if (navLink) {
      document.querySelectorAll('#navbar-actions .nav-link').forEach(link => {
        link.classList.remove('active');
      });
      navLink.classList.add('active');
    }
  });

  // Carousel functionality (for both testimonials and features)
  function initializeCarousel(containerSelector, slideSelector, dotSelector) {
    const container = document.querySelector(containerSelector);
    if (container) {
      const slides = container.querySelectorAll(slideSelector);
      const dots = container.querySelectorAll(dotSelector);
      
      function showSlide(slideIndex) {
        // Hide all slides
        slides.forEach(slide => {
          slide.classList.remove('active');
        });
        
        // Remove active class from all dots
        dots.forEach(dot => {
          dot.classList.remove('active');
        });
        
        // Show selected slide and activate corresponding dot
        if (slides[slideIndex]) {
          slides[slideIndex].classList.add('active');
        }
        if (dots[slideIndex]) {
          dots[slideIndex].classList.add('active');
        }
      }
      
      // Add click event listeners to dots
      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          showSlide(index);
        });
      });
      
      // Auto-advance slides every 5 seconds
      let currentSlide = 0;
      setInterval(() => {
        currentSlide = (currentSlide + 1) % slides.length;
        showSlide(currentSlide);
      }, 5000);
    }
  }

  // Initialize testimonial carousel
  initializeCarousel('.testimonial-slider', '.testimonial-slide', '.dot');
  
  // Initialize feature carousel
  function initializeFeatureCarousel() {
    const container = document.querySelector('.feature-carousel-container');
    if (container) {
      const slides = container.querySelectorAll('.feature-slide');
      const descriptions = container.querySelectorAll('.feature-description');
      const dots = container.querySelectorAll('.feature-dots .dot');
      
      function showSlide(slideIndex) {
        // Hide all slides
        slides.forEach(slide => {
          slide.classList.remove('active');
        });
        
        // Hide all descriptions
        descriptions.forEach(desc => {
          desc.classList.remove('active');
        });
        
        // Remove active class from all dots
        dots.forEach(dot => {
          dot.classList.remove('active');
        });
        
        // Show selected slide, description and activate corresponding dot
        if (slides[slideIndex]) {
          slides[slideIndex].classList.add('active');
        }
        if (descriptions[slideIndex]) {
          descriptions[slideIndex].classList.add('active');
        }
        if (dots[slideIndex]) {
          dots[slideIndex].classList.add('active');
        }
      }
      
      // Add click event listeners to dots
      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          showSlide(index);
        });
      });
      
      // Auto-advance slides every 5 seconds
      let currentSlide = 0;
      setInterval(() => {
        currentSlide = (currentSlide + 1) % slides.length;
        showSlide(currentSlide);
      }, 5000);
    }
  }
  
  initializeFeatureCarousel();

});

  
function initializeParallaxTimeline() {
  const section  = document.querySelector('.timeline-container');
  const track    = document.querySelector('.timeline-track');
  const scrollEl = document.querySelector('.timeline-scroll');
  if (!section || !track || !scrollEl) return;

  let totalX = 0, startY = 0, endY = 0, raf = 0;

  const px = v => {
    v = String(v).trim();
    if (v.endsWith('px')) return parseFloat(v);
    if (v.endsWith('vh')) return window.innerHeight * (parseFloat(v)/100);
    return parseFloat(v) || 0;
  };

  function bandHeight() {
    const cs = getComputedStyle(scrollEl);
    const pt = px(cs.getPropertyValue('--peek-top') || '0px');
    const pb = px(cs.getPropertyValue('--peek-bottom') || '0px');
    return Math.max(0, window.innerHeight - pt - pb);
  }

  const clamp = (v,a,b)=>Math.max(a,Math.min(b,v));

  function computeSizes() {
    const vw = window.innerWidth;
    const trackW = track.scrollWidth;
    const bandH  = bandHeight();

    totalX = Math.max(0, trackW - vw);

    // Vertical scroll budget = horizontal distance + band height
    section.style.height = (totalX + bandH) + 'px';

    startY = section.offsetTop;
    endY   = startY + totalX; // release right after consuming horizontal distance

    update();
  }

  function update() {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
      const y = window.scrollY;
      const d = clamp(y - startY, 0, totalX);
      const p = totalX ? d / totalX : 0;
      track.style.transform = `translate3d(${-totalX * p}px,0,0)`;
    });
  }

  new ResizeObserver(computeSizes).observe(track);
  window.addEventListener('resize', computeSizes, { passive:true });
  window.addEventListener('scroll', update, { passive:true });

  const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
  function motionPref() {
    if (mq.matches) {
      section.style.height = 'auto';
      track.style.transform = 'none';
      window.removeEventListener('scroll', update);
    } else {
      window.addEventListener('scroll', update, { passive:true });
      computeSizes();
    }
  }
  mq.addEventListener?.('change', motionPref);
  motionPref();
}
document.addEventListener('DOMContentLoaded', initializeParallaxTimeline);


const VALIDATORS = {

    validateColorInput: function (input) {
        input.removeClass('is-valid').removeClass('is-invalid')

        let color = input.val()

        if (!color) {
            return null
        }

        if (color.startsWith('#')) {
            color = color.substring(1)
        }

        if (color.length === 3) {
            color = color.split('').reduce((acc, c) => {
                return acc + c + c
            }, '')
        }

        const regex = /[0-9A-Fa-f]{6}/g
        if (color.match(regex)) {
            input.addClass('is-valid')
            return color
        }

        input.addClass('is-invalid')
        return null
    }
}
